import { useWsMatchMatches } from '@/app/core/websocket/hooks';
import { IWsMatch } from '@/app/core/websocket/models';
import { effect, Injectable, signal } from '@angular/core';
import { MatchApi } from '../../sports/football/home/models';

@Injectable({
  providedIn: 'root',
})
export class WebsocketFavortiesService {
  private wsMatches = useWsMatchMatches();
  constructor() {}

  // ✅ Señal para guardar último ws válido por partido
  readonly liveDataMap = signal<Record<string, Partial<MatchApi>>>({});

  wsMatchesData = signal<Record<string, IWsMatch>>({});

  wsDataMatches = effect(
    () => {
      this.wsMatchesData.set(this.wsMatches.data());
    },
    { allowSignalWrites: true }
  );

  wsDisconnect() {
    this.wsMatches.disconnect();
  }
}
